import React from 'react'
import DfbHeadline from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_headline'
import DfbImage from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_image'
import DfbRte from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_rte'
import Section from '@dfb/gatsby-dfb-theme/src/components/blocks/section'
import { Transformation } from 'cloudinary-react'
import { Image, MissionHero, MissionStatement } from '../../types/types'

const MMissionStatement = ({ data }) => {
  const {
    headline,
    image,
    mission_hero,
    mission_statement,
  }: {
    headline: string
    image: Array<Image> | null
    mission_hero: Array<MissionHero>
    mission_statement: Array<MissionStatement>
  } = data

  const sectionStyle = {}
  if (image?.[0]?.src) {
    sectionStyle['backgroundImage'] = `url(${image[0].src})`
  }

  return (
    <Section baseClass="m-MissionStatement" data={data} defaultPadding="large" add_style={sectionStyle}>
      <div className="m-MissionStatement-wrapper">
        <div className="m-MissionStatement-container">
          <div className="m-MissionStatement-content">
            {headline && <DfbHeadline headline={headline} headline_level="h2" add_class="m-MissionStatement-headline" />}
            <div className="m-MissionStatement-hero">
              <div className="m-MissionStatement-hero-image">
                <DfbImage image={mission_hero[0].image[0]} add_class="m-MissionStatement-image">
                  <Transformation crop="fill" gravity="faces:center" width="740" height="416" quality="auto" fetchFormat="auto" />
                </DfbImage>
              </div>
              <div className="m-MissionStatement-hero-content">
                {mission_hero[0].headline && <DfbHeadline headline={mission_hero[0].headline} headline_level="h4" />}
                <DfbRte text={mission_hero[0].text} add_class="m-MissionStatement-text" />
              </div>
            </div>
            <div className="m-MissionStatement-statements">
              {mission_statement?.map(({ headline, text }) => (
                <div className="m-MissionStatement-statement">
                  <DfbHeadline headline={headline} headline_level="h4" />
                  <DfbRte text={text} add_class="m-MissionStatement-text" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MMissionStatement
